import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "antd";
import { getUserInfo } from "../../services/localStorage";

const { Title, Paragraph } = Typography;

/** Where to send agents vs anonymous guests during HR/DP staging maintenance */
function resolveDashboardFallbackHref() {
  try {
    const u =
      typeof getUserInfo === "function" ? getUserInfo() : null;
    const ut = String(u?.usertype ?? u?.userType ?? "").toLowerCase();
    if (ut === "agents" || ut === "agent") {
      return "/p/dashboard/home";
    }
    return "/";
  } catch {
    return "/";
  }
}

/**
 * Clean maintenance screen for gated Dynamic Packages / HotelsRiver Packages flows.
 */
const DynamicPackagesMaintenanceWall = ({
  subtitle = "",
  className = "",
}) => {
  const navigate = useNavigate();

  const onBackDashboard = useCallback(() => {
    navigate(resolveDashboardFallbackHref());
  }, [navigate]);

  return (
    <div
      dir="rtl"
      className={`tw-flex tw-min-h-[50vh] tw-w-full tw-items-center tw-justify-center tw-bg-white tw-p-6 ${className}`}
      role="status"
      aria-live="polite"
    >
      <div className="tw-max-w-lg tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-neutral-50 tw-p-8 tw-text-center tw-shadow-sm">
        <Title level={3} className="!tw-mt-0 !tw-text-neutral-900">
          חבילה דינמית אינה זמינה כרגע
        </Title>
        {subtitle ? (
          <Paragraph type="secondary" className="!tw-mb-6">
            {subtitle}
          </Paragraph>
        ) : (
          <Paragraph type="secondary" className="!tw-mb-6">
            המוצר אינו פעיל כרגע. ניתן להמשיך להזמנות מלונות, חבילות, טיסות ושייט.
          </Paragraph>
        )}
        <Button type="primary" size="large" onClick={onBackDashboard} block>
          חזור לדשבורד
        </Button>
      </div>
    </div>
  );
};

export default DynamicPackagesMaintenanceWall;
